import { ReactComponent as Content } from '../../../assets/color/Content.svg?react';
import { createIcons } from '../../Icon';
export const ContentIcon = createIcons('Content', {
    default: Content
});
